import React from "react";

export default class AudioPlayer extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return <audio {...this.props} />;
  }
}
